module.exports = __webpack_public_path__ + "static/media/agency-skill.f6fa4968.jpg";